export const APPLICATION_BANK_ACCOUNT_TYPE_OPTIONS = [
  { value: '普通預金', label: '普通預金' },
  { value: '当座預金', label: '当座預金' },
  { value: '貯蓄', label: '貯蓄' },
  { value: 'その他', label: 'その他' },
];

export const bankAccountTypeLabelFromDb = (value: number | null | undefined): string => {
  switch (value) {
    case 1:
      return '普通預金';
    case 2:
      return '当座預金';
    case 4:
      return '貯蓄';
    case 9:
      return 'その他';
    default:
      return '';
  }
};

export const normalizeApplicationBankAccountType = (value: unknown): string => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  if (/^1(?:[:：=＝]|$)/.test(raw) || raw.includes('普通')) return '普通預金';
  if (/^2(?:[:：=＝]|$)/.test(raw) || raw.includes('当座')) return '当座預金';
  if (/^4(?:[:：=＝]|$)/.test(raw) || raw.includes('貯蓄')) return '貯蓄';
  if (/^9(?:[:：=＝]|$)/.test(raw) || raw.includes('その他')) return 'その他';

  return raw;
};

export const bankAccountTypeToDb = (value: unknown): number | null => {
  const normalized = normalizeApplicationBankAccountType(value);
  switch (normalized) {
    case '普通預金':
      return 1;
    case '当座預金':
      return 2;
    case '貯蓄':
      return 4;
    case 'その他':
      return 9;
    default:
      return null;
  }
};
